import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import SvgIcon from '../../SvgIcon';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M7.5 8.8c-.358 0-.683-.146-.919-.381l1.838-1.838c.235.236.381.561.381.919 0 .717-.583 1.3-1.3 1.3m0-3.8C6.119 5 5 6.119 5 7.5S6.119 10 7.5 10 10 8.881 10 7.5 8.881 5 7.5 5m0-1.8c-2.228 0-4.379 1.521-6.106 4.3 1.727 2.779 3.878 4.3 6.106 4.3 2.228 0 4.379-1.521 6.106-4.3C11.879 4.721 9.728 3.2 7.5 3.2m0 9.8C4.916 13 2.331 11.338.302 8.015.11 7.7.11 7.3.302 6.985 2.331 3.662 4.916 2 7.5 2c2.584 0 5.169 1.662 7.198 4.985.192.315.192.715 0 1.03C12.669 11.338 10.084 13 7.5 13M0 0v15m15 0V0",
  fillRule: "evenodd"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0 20V0v20zM20 0v20V0zM10 7c-.768 0-1.536.293-2.121.879-1.172 1.171-1.172 3.071 0 4.242.585.586 1.353.879 2.121.879s1.536-.293 2.121-.879c1.172-1.171 1.172-3.071 0-4.242C11.536 7.293 10.768 7 10 7zm-1.061 4.061c-.585-.585-.585-1.537 0-2.122.284-.283.66-.439 1.061-.439.401 0 .777.156 1.061.439l-2.122 2.122zM10 4C6.897 4 3.795 5.814 1.359 9.443c-.222.332-.222.782 0 1.114C3.795 14.186 6.897 16 10 16c3.103 0 6.205-1.814 8.641-5.443.222-.332.222-.782 0-1.114C16.205 5.814 13.103 4 10 4zm0 1.5c2.632 0 5.165 1.59 7.204 4.5-2.039 2.91-4.572 4.5-7.204 4.5-2.632 0-5.165-1.59-7.204-4.5C4.835 7.09 7.368 5.5 10 5.5z",
  fillRule: "evenodd"
});

export default function EyeIcon(props) {
  return React.createElement(SvgIcon, _extends({
    viewBox: function viewBox(size) {
      return size < 20 ? '0 0 15 15' : '0 0 20 20';
    }
  }, props), function (size) {
    return size < 20 ? _ref : _ref2;
  });
}
EyeIcon.displayName = 'EyeIcon';